import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import "../../../assets/css/vertical-responsive-menu.min.css";
import "../../../assets/css/v3.css";
import "./SideNavMenu.css";
import { images } from "../../../assets/images";
import SideNavMenu from "./SideNavMenu";
import EventSideNavMenu from "../../../pages/Event/EventSideNavMenu";
import { getOrganizerProfile } from "../../../api";
import { useNightMode } from "../../../contexts/NightModeContext";
import { useNavTitle } from "../../../contexts/NavTitleContext";
import UserEventSideNavMenu from "../../../pages/NewUser/UserEventSideNavMenu";
import OrganizerSearchBar from "../../organizer/OrganizerSearchBar";
import OrganizerSpotlight from "../../organizer/OrganizerSpotlight";

type HeaderProps = {
  onChangeMenu: () => void;
};

const Header = (props: HeaderProps) => {

  const { onChangeMenu } = props;
  const location = useLocation();
  const { isNightMode, toggleNightMode } = useNightMode();
  const { navTitle } = useNavTitle();
  const [organizer, setOrganizer] = useState({
    name: '',
    email: '',
    profilePic: '' as string | undefined
  });
  const userData = useMemo(() => {
    const userData = localStorage.getItem("userData");
    return userData ? JSON.parse(userData) : { name: '', email: '',venueName: '' };
  }, []);
  const isVenueEventRoute = location.pathname.startsWith("/venue-event/");
  const eventId = useMemo(() => {
    const eventData = localStorage.getItem("eventData");
    return eventData ? JSON.parse(eventData).eventId : null;
  }, []); 
  const [showDropDown, setShowDropDown] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const [minifyNav, setMinifyNav] = useState(false);
  const [mobileNavBarOpen, setMobileNavBarOpen] = useState(false);
  const [activeSideNav, setActiveSideNav] = useState("common");

  const onClickToggleBar = () => {
    setMinifyNav(!minifyNav);
    onChangeMenu();
  };
  const dropdownRef = useRef<HTMLLIElement>(null); // reference to the dropdown

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setShowDropDown(false);
      }
    };
    const handleScroll = () => {
      setShowDropDown(false);
    };
    const handleTouch = () => {
      setShowDropDown(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("touchstart", handleTouch, { passive: true });
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("touchstart", handleTouch);
    };
  }, []);

  useEffect(() => {
    if (mobileNavBarOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileNavBarOpen]);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const eventData = localStorage.getItem("eventData");
        if (eventData) {
          const eventSlug = JSON.parse(eventData).organizerId;
        }
          const response = await getOrganizerProfile();
          console.log("Organizer Data:", response);
          setOrganizer({
            name: response.name,
            email: response.email,
            profilePic: response.profilePic,
          });
        
          localStorage.setItem("organizerData", JSON.stringify(response));
        
      } catch (error) {
        console.error("Error fetching organizer profile:", error);
      }
    };

    fetchData();

    console.log("location", location.pathname);
    if (location.pathname.includes("/event/")) {
      setActiveSideNav("event");
    }
    else if (location.pathname.includes("/venue-event/")) {
      setActiveSideNav("venue-event");
    }
     else {
      setActiveSideNav("common");
    }
  }, [location.pathname]);
  const [showHeader, setShowHeader] = useState(true);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY.current && currentScrollY > 50) {
        setShowHeader(false);
      } else {
        setShowHeader(true);
      }
      lastScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const currentMenuTitle = navTitle;

  return (
    <>
      {/* Global command palette — Ctrl/Cmd+K; page search bars open this too */}
      <OrganizerSpotlight />

      {/* Mobile Floating Capsule Header */}
      <div
        className="mobile-floating-header align-items-center justify-content-between"
        style={{
          opacity: mobileNavBarOpen || !showHeader ? 0 : 1,
          transform: (mobileNavBarOpen || !showHeader) ? 'translateY(-70px) scale(0.97)' : 'translateY(0) scale(1)',
          pointerEvents: (mobileNavBarOpen || !showHeader) ? 'none' : 'auto',
          transition: 'opacity 0.3s ease, transform 0.3s ease'
        }}
      >
        {/* Left: Eventox Logo Icon + Selected Menu Title */}
        <div className="d-flex align-items-center gap-3" style={{ minWidth: 0, flex: '0 1 auto' }}>
          <img
            src={isNightMode ? images.white_icon : images.grey_logo}
            alt="Eventox Icon"
            className="mobile-header-logo"
            style={{ width: '28px', height: '28px', objectFit: 'contain', flexShrink: 0 }}
          />
          <span className="mobile-header-title">
            {currentMenuTitle}
          </span>
        </div>

        {/* Spotlight trigger when page has no desktop search (e.g. event pages) */}
        <div className="d-flex align-items-center mx-2" style={{ flex: '1 1 auto', minWidth: 0, maxWidth: 180 }}>
          <OrganizerSearchBar compact />
        </div>

        {/* Right: Hamburger / X Toggle Button */}
        <button
          type="button"
          id="toggleMenu"
          className="mobile-header-toggle-btn"
          onClick={() => setMobileNavBarOpen(!mobileNavBarOpen)}
          aria-label="Toggle menu"
          style={{ flexShrink: 0 }}
        >
          <i className={`fa-solid ${mobileNavBarOpen ? 'fa-xmark' : 'fa-bars'}`}></i>
        </button>
      </div>

      {mobileNavBarOpen && (
        <div
          className="mobile-sidenav-backdrop"
          onClick={() => setMobileNavBarOpen(false)}
        />
      )}
      {activeSideNav === "common" && (
        <SideNavMenu
          minifyNav={minifyNav}
          mobileNavOpen={mobileNavBarOpen}
          setMobileNavBarOpen={setMobileNavBarOpen}
        />
      )}
      {activeSideNav === "event" && (
        <EventSideNavMenu
          minifyNav={minifyNav}
          mobileNavOpen={mobileNavBarOpen}
          setMobileNavBarOpen={setMobileNavBarOpen}
        />
      )}
      {activeSideNav === "venue-event" && (
        <UserEventSideNavMenu
          minifyNav={minifyNav}
          mobileNavOpen={mobileNavBarOpen}
          setMobileNavBarOpen={setMobileNavBarOpen}
        />
      )}
    </>
  );
};

export default Header;
